(() => {
    const bnplScriptUrls = {
        afterpay: 'https://js.afterpay.com/afterpay-1.x.js',
        paypal: 'https://www.paypal.com/sdk/js?client-id=AeoUO9cc8kBTmmqj0IQsmNXzZWXlWDtCSdS7W9yLnq_T7_xy19SCnFk3JocJlI6jiKPd8KR9NWwo0BZz&components=messages,buttons',
        zip: 'https://static.zip.co/lib/js/zm-widget-js/dist/zip-widget.min.js'
    };

    const bnplScriptPromises = {};

    class BNPLMessaging extends HTMLElement {
        constructor() {
            super();
            this.amountElement = this.querySelector('[data-bnpl-amount]');
            this.zipWidget = this.querySelector('#zip-product-widget');
            this.total = (this.getAttribute('data-subtotal') || '0').replace(/[^\d.]/g, '');
            this._total = this.total;
        }
        connectedCallback() {
            this.validateBnplLimits(this.total);
            if (this.dataset.disablePopups != "true") {
                this.bindPopupHandlers();
            }
            subscribe(PUB_SUB_EVENTS.assemblyAdded, ({ price }) => {
                this.updateMessaging(+this._total + price);
            })
            subscribe(PUB_SUB_EVENTS.assemblyRemoved, ({ price }) => {
                this.updateMessaging(+this.total - price);
            })
        }
        bindPopupHandlers() {
            this.querySelector('.icon.icon-afterpay-black')?.addEventListener('click', () => {
                this.openAfterpayModal();
            });
            this.querySelector('.icon.icon-paypal')?.addEventListener('click', () => {
                this.openPaypalModal();
            });
            this.querySelector('.icon.icon-zip')?.addEventListener('click', () => {
                this.openZipModal();
            });
        }
        static loadScriptOnce(src, attrs = {}) {
            if (!src) return Promise.resolve(null);
            if (window.luxoLoadScriptOnce) return window.luxoLoadScriptOnce(src, attrs);
            if (bnplScriptPromises[src]) return bnplScriptPromises[src];

            bnplScriptPromises[src] = new Promise((resolve, reject) => {
                const normalizedSrc = new URL(src, document.baseURI).href;
                const existingScript = Array.from(document.scripts).find((script) =>
                    script.src === normalizedSrc || script.getAttribute('src') === src
                );

                if (existingScript?.dataset.loaded === 'true') {
                    resolve(existingScript);
                    return;
                }

                const script = existingScript || document.createElement('script');
                const onLoad = () => {
                    script.dataset.loaded = 'true';
                    resolve(script);
                };
                const onError = () => reject(new Error(`Failed to load script: ${src}`));

                script.addEventListener('load', onLoad, { once: true });
                script.addEventListener('error', onError, { once: true });

                if (!existingScript) {
                    script.src = src;
                    Object.entries(attrs).forEach(([key, value]) => {
                        if (value === true) script.setAttribute(key, key);
                        else if (value !== false && value != null) script.setAttribute(key, value);
                    });
                    (document.body || document.head).appendChild(script);
                }
            });

            return bnplScriptPromises[src];
        }
        static handlePopupLoadError(error) {
            console.warn('BNPL popup unavailable', error);
        }
        openAfterpayModal() {
            BNPLMessaging.loadScriptOnce(bnplScriptUrls.afterpay, { async: true })
                .then(() => {
                    window.Afterpay?.launchModal('en_AU');
                })
                .catch(BNPLMessaging.handlePopupLoadError);
        }
        openPaypalModal() {
            BNPLMessaging.loadScriptOnce(bnplScriptUrls.paypal, {
                async: true,
                'data-namespace': 'PayPalSDK'
            })
                .then(() => {
                    window.PayPalSDK?.MessagesModal("")?.show();
                })
                .catch(BNPLMessaging.handlePopupLoadError);
        }
        openZipModal() {
            BNPLMessaging.loadScriptOnce(bnplScriptUrls.zip, { async: true })
                .then(() => {
                    setTimeout(() => {
                        this.zipWidget?.click();
                    }, 150);
                })
                .catch(BNPLMessaging.handlePopupLoadError);
        }
        /**
         * @param {Number} grandTotal  
         */
        updateMessaging(grandTotal) {
            this.total = grandTotal;
            this.setAttribute('data-subtotal', grandTotal);
            if (this.amountElement) {
                const installmentAmount = (grandTotal / 4).toFixed(2).replace(/\.00$/, '');
                this.amountElement.textContent = `$${installmentAmount}`;
                this.amountElement.setAttribute('data-bnpl-amount', installmentAmount);
            }
            this.validateBnplLimits(grandTotal);
        }
        /**
         * 
         * @param {Number | string} grandTotal 
         */
        validateBnplLimits(grandTotal) {
            const limits = [
                { className: "hide-afterpay", limit: 4000, compare: (v, l) => v > l },
                { className: "hide-zip", limit: 1500, compare: (v, l) => v > l },
                { className: "hide-paypal", limit: 2000, compare: (v, l) => v >= l }
            ];
            const value = Number(grandTotal);
            limits.forEach(({ className, limit, compare }) => {
                this.classList.toggle(className, compare(value, limit));
            });
        }
    }
    if (!customElements.get('bnpl-messaging')) {
        customElements.define('bnpl-messaging', BNPLMessaging);
    }
})();
